/**
 * Smartphone / mobile device — used by the IDE preview device-frame cycle.
 */
export const deviceMobile = {
    paths: [
        {
            d: 'M3.75 0h8.5C13.216 0 14 .784 14 1.75v12.5A1.75 1.75 0 0 1 12.25 16h-8.5A1.75 1.75 0 0 1 2 14.25V1.75C2 .784 2.784 0 3.75 0ZM3.5 1.75v12.5c0 .138.112.25.25.25h8.5a.25.25 0 0 0 .25-.25V1.75a.25.25 0 0 0-.25-.25h-8.5a.25.25 0 0 0-.25.25ZM8 13a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z',
        },
    ],
    viewBox: '0 0 16 16',
};
//# sourceMappingURL=device-mobile.js.map